export default __webpack_public_path__ + "static/15-hacker-1799b160a6ea6175cb6475fc4a8cea72.png";